module.exports = __webpack_public_path__ + "static/media/how1.199ab7bd.png";